<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0 tiles">
      <b-card-header id="orderplaced-card-header" class="pl-2 pr-3 small relative z-1">
        <b-row>
          <b-col>STAFFTRAV Emissions</b-col>
          <b-col cols="12" md="5">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-clock"></i>
              </template>
              <b-dropdown-item v-for="timerange in timeranges" :key="timerange" @click="handleUpdate(timerange)">{{
                timerange }}</b-dropdown-item>
            </b-dropdown>
            <div class="mb-0 text-right pr-4">In the last: {{ timerange }}</div>
          </b-col></b-row>
      </b-card-header>
      <b-card-body class="px-0 pt-0">
        <div id="ticketsemissions" class="px-0 mx-0 text-left">
          <d-table
            classdivtable="availtable datatable sheets"
            refid="ticketsemissions"
            :icon="ticketsemissions.icon"
            :tools="ticketsemissions.tools"
            :toolbarlibrary="ticketsemissions.toolbarlibrary"
            :toolbarinit="ticketsemissions.toolbarinit"
            :badges="ticketsemissions.badges"
            :fields="ticketsemissions.fields"
            :items="ticketsemissions.items"
            :busy="ticketsemissions.busy"
            :showpages="false"
            @load="load" 
            @click="ticketsemissions_click"
            @select="ticketsemissions_select"
          >
          </d-table>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>
  
<script>
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "TickEmissions",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "TickEmissions",
      timerange: "90 days",
      timeranges: ["30 days", "60 days", "90 days", "180 days", "365 days"],
      items: [],
      ticketsemissions: {
        title: "Your Tickets",
        icon: "fa fa-ticket text-orange",
        debounce: 500,
        busy: false,
        page: 1,
        sheet: "zhold",
        tools: "go,export,copy",
        fields: [
          // {
          //   key: "selected",
          //   label: "...",
          //class: "text-center w-25px",
          // },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-danger nowrap",
          },
          // {
          //   key: "locator",
          //   label: "Locator",
          //   sortable: true,
          //   class: "",
          // },
          // {
          //   key: "ticketno",
          //   label: "TicketNo",
          //   sortable: true,
          //   class: "",
          // },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          // {
          //   key: "slac",
          //   label: "SL A/C",
          //   sortable: true,
          //   class: "text-center",
          // },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "passenger",
            label: "Passenger",
            class: "text-left",
            sortable: true,
            // formatter: (value, key, item) => {
            //   let result = value;
            //   if (value.length >= 20) {
            //     result = value.slice(0, 17) + " ...";
            //   }
            //   return result;
            // },
          },
          // {
          //   key: "datetravel",
          //   label: "Date Travel",
          //   sortable: true,
          //   class: "text-right",
          //   formatter: (value, key, item) => {
          //     let result = "";
          //     if (value) {
          //       result = this.$moment
          //         .unix(value / 1000)
          //         .utc(false)
          //         .format("DD/MM/YYYY HH:mm:SS");
          //     }
          //     return result;
          //   },
          // },
          // {
          //   key: "flightno",
          //   label: "FlightNo",
          //   class: "text-center",
          //   sortable: true,
          // },
          // {
          //   key: "cabin",
          //   label: "Cabin",
          //   class: "text-center",
          //   sortable: true,
          // },
          {
            key: "routing",
            label: "Routing",
            class: "text-center",
            sortable: true,
          },
          {
            key: "aircraft",
            label: "Equipment",
            sortable: true,
            class: "",
          },
          {
            key: "emission",
            label: "Emissions CO2",
            sortable: true,
            class: "",
            totalled: true,
            total: 0,
          },
        ],
        items: [],
        badges: [
          {
            key: "progress",
            type: "progressbar",
            class: "warning",
          },
        ],
      },
    };
  },
  async mounted() {
    await this.load()();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
  },
  methods: {
    async load() {
      console.log("loadChart: orderplaced", this.timerange);

      this.busy = true;
      let from = null;
      switch (this.timerange) {
        case "30 days":
          from = moment().add(-30, "days").format("YYYY-MM-DD");
          break;
        case "60 days":
          from = moment().add(-60, "days").format("YYYY-MM-DD");
          break;
        case "90 days":
          from = moment().add(-90, "days").format("YYYY-MM-DD");
          break;
        case "180 days":
          from = moment().add(-180, "days").format("YYYY-MM-DD");
          break;
        case "365 days":
          from = moment().add(-365, "days").format("YYYY-MM-DD");
          break;
      }
      let variables = {
        mssql: true,
        dateissued: [
          this.$moment().startOf("year").format("YYYY-MM-DD"),
          this.$moment().endOf("year").format("YYYY-MM-DD"),
        ],
        orderby: [["[travel_at]", "asc"]],
        slac: "STAFFTRAV",
        type: "TICKET,REISSUE,CHARTER",
        isemissioned: true
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $mssql: Boolean
              $dateissued: [String]
              $type: String
              $slac: String
              $isemissioned: Boolean
              $orderby: [[String]]
            ) {
              tickets(
                mssql: $mssql
                dateissued: $dateissued
                type: $type
                slac: $slac
                isemissioned: $isemissioned
                orderby: $orderby
              ) {
                id
                datetravel
                passenger
                flightno
                cabin
                routing
                eventcode
                aircraft
                emission
                rows
              }
            }
          `,
          variables,
        });
        this.ticketsemissions.items = response.data.tickets;

      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
    async handleUpdate(update) {
      console.log("handleUpdate", update);
      this.timerange = update;
      await this.loadChart();
    },
    async ticketsemissions_click(a, ss) {

      let state = this.ticketsemissions;

      switch (a) {

        case "go":
          this.component = null;
          //   this.dateSelector();
          await this.load();
          break;

      }
    },
    async ticketsemissions_select(ss, tools) {
      console.log("ticketsemissions_select", ss);

      let state = this.ticketsemissions;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["go", "filter", "add", "export", "copy"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }

      if (state.selected.length > 0) {
        state.item = state.selected[0]; // WHAT YOU SELECTED
      } else {
        state.item = {}
      }
    },
  },
};
</script>
  
  
<style></style>